export default "__VITE_ASSET__DxgEia3C__"